import SlimSelect from "slim-select"

function initServiceForm() {
  const colorSelect = document.querySelector(".service-color-select")
  const modelSelect = document.querySelector(".service-model-select")

  if (!colorSelect || !modelSelect) return

  // Set data-html on options with icons before SlimSelect init
  setOptionHtml(colorSelect)
  setOptionHtml(modelSelect)

  const allModelData = Array.from(modelSelect.querySelectorAll("option")).map(
    (opt) => ({
      text: opt.textContent,
      html: opt.dataset.html || "",
      value: opt.value,
      placeholder: !opt.value,
    }),
  )

  new SlimSelect({
    select: colorSelect,
    settings: {
      showSearch: false,
      placeholderText: "",
    },
    events: {
      afterChange: () => {
        filterModels(colorSelect, modelSelect, modelSlim, allModelData)
      },
    },
  })

  const modelSlim = new SlimSelect({
    select: modelSelect,
    settings: {
      showSearch: false,
      placeholderText: "",
    },
  })
}

function filterModels(colorSelect, modelSelect, modelSlim, allModelData) {
  const selectedOption = colorSelect.options[colorSelect.selectedIndex]
  const modelIds = (selectedOption?.dataset.modelIds || "")
    .split(",")
    .filter(Boolean)
  const currentModel = modelSelect.value

  const withAvailability = allModelData.map((opt) => {
    const available =
      opt.placeholder || modelIds.length === 0 || modelIds.includes(opt.value)
    return opt.html
      ? { ...opt, html: opt.html, disabled: !available }
      : { ...opt, disabled: !available }
  })

  modelSlim.setData(withAvailability)

  if (currentModel && modelIds.length > 0 && !modelIds.includes(currentModel)) {
    modelSlim.setSelected("")
  } else if (currentModel) {
    modelSlim.setSelected(currentModel)
  }
}

function setOptionHtml(select) {
  select.querySelectorAll("option[data-icon]").forEach((opt) => {
    if (!opt.dataset.icon) return
    opt.dataset.html =
      '<img src="' + opt.dataset.icon + '"><span>' + opt.textContent + "</span>"
  })
}

document.addEventListener("DOMContentLoaded", initServiceForm)
